import { PanelDrawer } from "@theme/panel-drawer";

/**
 * Free gift side panel. The shell (hash links, drag to dismiss, editor
 * preview, open event) lives in PanelDrawer; this adds the footer swap.
 *
 * `#free-gift-panel` opens with the first footer (build your own box);
 * `#free-gift-panel-<name>` opens with the footer whose `data-footer` is `<name>`.
 *
 * @extends PanelDrawer
 */
class FreeGiftDrawer extends PanelDrawer {
  /**
   * Shows the footer matching `name`, hides the others. Falls back to the
   * first footer when nothing matches so the CTA never disappears.
   *
   * @param {string} name
   * @returns {{ panel_footer: string } | void}
   */
  prepare(name) {
    const footers = Array.from(this.querySelectorAll("[data-footer]")).filter(
      (footer) => footer instanceof HTMLElement,
    );
    if (footers.length === 0) return;

    const match =
      footers.find((footer) => footer.getAttribute("data-footer") === name) ??
      footers[0];
    if (!match) return;

    for (const footer of footers) {
      footer.hidden = footer !== match;
    }

    return { panel_footer: match.getAttribute("data-footer") ?? "" };
  }
}

if (!customElements.get("free-gift-drawer")) {
  customElements.define("free-gift-drawer", FreeGiftDrawer);
}
